import { Divider, Card, List, Tag } from 'antd';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ProductContext } from '../Context/ProductContext';
import { ThemeContext } from '../Context/ThemeContext';
import { UserContext } from '../Context/UserContext';

function ProductList() {
  const [,,,setDashboard] = useContext(UserContext)
  const [listOfProduct,,loading] = useContext(ProductContext)
  const [theme] = useContext(ThemeContext)
  let history = useHistory()

  setDashboard(false)
  const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''

  const HandleDetail = async (event) => {
    let idProduct = Number(event.target.value)

    history.push(`/product/detail/${idProduct}`)
  }

  const HandleBuy = async (event) => {
    let idProduct = Number(event.target.value)

    history.push(`/create-order/${idProduct}`)
  }

  return (
    <>
      <Divider className={changeNameClass} orientation="center" style={{fontSize: "30px"}}>
          OUR PRODUCTS
      </Divider>
      <div style={{marginTop: "50px"}}>
        <List 
          pagination={{
              pageSize: 15
            }}
          grid = {{column: 5}}
          loading={loading}
          dataSource={listOfProduct}
          renderItem={el => (
          
            <List.Item>
            <div className={changeNameClass + ' card'}>
            <Card className={changeNameClass} key={el.id} style={{margin: "10px", boxShadow: "3px 3px 1px 1px #009FB7", borderRadius: "20px", height: "440px", width:"225px"}}
            cover={<img src={el.image} alt="banner-product" style={{width: "100%", height: "auto", maxHeight: "225px", color: "#272727", borderRadius: "20px 20px 0px 0px"}}/>}>
              {el.category.map(function(item){
                return (
                  <Tag color="#f50" style={{margin: "5px 2px 0px 0px", height: "22px"}}>
                    <p style={{fontSize: "12px", color:"white"}}>{item.category.name}</p>
                  </Tag>
                )
              })}
              <h1 style={{whiteSpace: "pre-wrap", overflow: "hidden", textOverflow: "ellipsis", wordBreak:"keep-all",display: "-webkit-box", WebkitLineClamp: "2", WebkitBoxOrient: "vertical"}}>{el.name}</h1>
              <h3>Rp. {el.price}</h3>
              <div className='card-button'>
                <button className="button-7" onClick={HandleDetail} value={el.id} >Detail</button>
                <button className="button-7" onClick={HandleBuy} value={el.id} style={{marginLeft: "10px"}}>Add to Cart</button>
              </div>
            </Card>
            </div>
          </List.Item>
          
            )}
        />
      </div>
    </>
  );
}

export default ProductList;